<script setup>
import "vue3-carousel/carousel.css";
import { Carousel, Slide, Navigation } from "vue3-carousel";
import { useSupabaseClient, useI18n } from "#imports";
import { ref, onMounted } from "vue";

const { t } = useI18n();
const supabase = useSupabaseClient();

const sponsorlogo = ref([]);

onMounted(async () => {
  const { data, error } = await supabase.from("sponsor_logos").select("*");
  if (error) {
    console.error("Sponsor logoları alınamadı:", error);
  } else {
    sponsorlogo.value = data || [];
  }
});

const config = {
  height: 100,
  itemsToShow: 4,
  gap: 5,
  autoplay: 2000,
  loop: true,
  wrapAround: true,
  pauseAutoplayOnHover: true,
};
</script>

<template>
  <div class="w-full bg-[#111] py-8">
    <Carousel v-bind="config">
      <Slide v-for="logo in sponsorlogo" :key="logo.id">
        <div div class="flex justify-center items-center h-full">
          <img
            :src="logo.image_url"
            :alt="logo.alt"
            class="h-20 object-contain lg:grayscale lg:hover:grayscale-0 transition duration-300"
          />
        </div>
      </Slide>

      <template #addons>
        <Navigation />
      </template>
    </Carousel>
  </div>
</template>

<style>
:root {
  background-color: #242424;
}

.carousel {
  --vc-nav-background: rgba(255, 255, 255, 0.7);
  --vc-nav-border-radius: 100%;
}

img {
  border-radius: 8px;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
